import { apiRutaSegura } from '../enviroment/apileadsRutaSegura'
import loaderService from "./loaderService"

const getToken = () =>
  JSON.parse(sessionStorage.getItem('userInfo')).token || null

const authHeaders = () => ({
  Authorization: `${getToken()}`,
})

export const getIam = async () => {
  try {
    const response = await apiRutaSegura.get('/v1/rutas/obtener', {
      headers: authHeaders(),
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

/**
 * POST /v1/rutas/crear - Crea una nueva ruta
 * @param {{ nombre_ruta: string }} body
 */
export const crearRuta = async (body) => {
  try {
    const response = await apiRutaSegura.post('/v1/rutas/crear', body, {
      headers: authHeaders(),
    })
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return null
  } catch (error) {
    console.error('Error al crear ruta:', error)
    throw error
  }
}

/**
 * PUT /v1/rutas/actualizar - Actualiza una ruta
 * @param {{ id_ruta: number, nombre_ruta: string, codigo_qr: string, estado: number }} body
 */
export const actualizarRuta = async (body) => {
  try {
    const response = await apiRutaSegura.put('/v1/rutas/actualizar', body, {
      headers: authHeaders(),
    })
    if (response.status === 200) {
      return response.data
    }
    return null
  } catch (error) {
    console.error('Error al actualizar ruta:', error)
    throw error
  }
}

/**
 * DELETE /v1/rutas/eliminar?id_ruta={id_ruta} - Elimina una ruta
 * @param {number} idRuta - ID de la ruta
 */
export const eliminarRuta = async (idRuta) => {
  try {
    const response = await apiRutaSegura.delete(
      `/v1/rutas/eliminar?id_ruta=${idRuta}`,
      { headers: authHeaders() }
    )
    if (response.status === 200) {
      return response.data
    }
    return null
  } catch (error) {
    console.error('Error al eliminar ruta:', error)
    throw error
  }
}

/**
 * POST /v1/rutas/regenerar_qr?id_ruta={id_ruta} - Regenera el código QR de una ruta
 * @param {number} idRuta - ID de la ruta
 */
export const regenerarQr = async (idRuta) => {
  try {
    const response = await apiRutaSegura.post(
      `/v1/rutas/regenerar_qr?id_ruta=${idRuta}`,
      {},
      { headers: authHeaders() }
    )
    if (response.status === 200) {
      return response.data
    }
    return null
  } catch (error) {
    console.error('Error al regenerar QR:', error)
    throw error
  }
}

/**
 * GET /v1/usuarios/obtener - Obtiene la lista de usuarios
 */
export const getUsuarios = async () => {
  try {
    const response = await apiRutaSegura.get('/v1/usuarios/obtener', {
      headers: authHeaders(),
    })
    if (response.status === 200) {
      return response.data
    }
    return null
  } catch (error) {
    console.error('Error al obtener usuarios:', error)
    throw error
  }
}

/**
 * POST /v1/usuarios/registrar - Registra un nuevo usuario
 * @param {{ nombre_completo: string, cedula?: string, celular: string|number }} body
 */
export const registrarUsuario = async (body) => {
  try {
    const response = await apiRutaSegura.post('/v1/usuarios/registrar', body, {
      headers: authHeaders(),
    })
    if (response.status === 200 || response.status === 201) {
      return response.data
    }
    return null
  } catch (error) {
    console.error('Error al registrar usuario:', error)
    throw error
  }
}

/**
 * PUT /v1/usuarios/actualizar - Actualiza un usuario existente
 * @param {{ id_usuario: number, nombre_completo: string, cedula?: string, celular: string, estado: number }} body
 */
export const actualizarUsuario = async (body) => {
  try {
    const response = await apiRutaSegura.put('/v1/usuarios/actualizar', body, {
      headers: authHeaders(),
    })
    if (response.status === 200) {
      return response.data
    }
    return null
  } catch (error) {
    console.error('Error al actualizar usuario:', error)
    throw error
  }
}

export default getIam